import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'ta',
  months: [
    'ஜனவரி',
    'பிப்ரவரி',
    'மார்ச்',
    'ஏப்ரல்',
    'மே',
    'ஜூன்',
    'ஜூலை',
    'ஆகஸ்ட்',
    'செப்டம்பர்',
    'அக்டோபர்',
    'நவம்பர்',
    'டிசம்பர்',
  ],
  monthsShort: ['ஜன', 'பிப்', 'மார்ச்', 'ஏப்', 'மே', 'ஜூன்', 'ஜூலை', 'ஆக', 'செப்', 'அக்', 'நவ', 'டிச'],
  weekdays: [
    'ஞாயிறுக்கிழமை',
    'திங்கட்கிழமை',
    'செவ்வாய்க்கிழமை',
    'புதன்கிழமை',
    'வியாழக்கிழமை',
    'வெள்ளிக்கிழமை',
    'சனிக்கிழமை',
  ],
  weekdaysMin: ['ஞா', 'தி', 'செ', 'பு', 'வி', 'வெ', 'ச'],
  weekdaysShort: ['ஞாயி', 'திங்', 'செவ்', 'புதன்', 'வியா', 'வெள்', 'சனி'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd, D MMMM HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd, D MMM YYYY h:mm A',
    'llll-Y': 'ddd, D MMM h:mm A',
    'll-Y+w': 'MMM D, ddd',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM, YYYY, HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: '%s ஆண்டிற்கு முன்', other: '%s ஆண்டுகளுக்கு முன்' },
    M: { one: '%s மாத. முன்', other: '%s மாத. முன்' },
    w: { one: '%s வார. முன்', other: '%s வார. முன்' },
    d: { one: '%s நாளுக்கு முன்', other: '%s நாட்களுக்கு முன்' },
    h: { one: '%s மணி. முன்', other: '%s மணி. முன்' },
    m: { one: '%s நிமி. முன்', other: '%s நிமி. முன்' },
    s: { one: '%s விநா. முன்', other: '%s விநா. முன்' },
  },
  future: {
    y: { one: '%s ஆண்டில்', other: '%s ஆண்டுகளில்' },
    M: { one: '%s மாத.', other: '%s மாத.' },
    w: { one: '%s வார.', other: '%s வார.' },
    d: { one: '%s நாளில்', other: '%s நாட்களில்' },
    h: { one: '%s மணி.', other: '%s மணி.' },
    m: { one: '%s நிமி.', other: '%s நிமி.' },
    s: { one: '%s விநா.', other: '%s விநா.' },
  },
  abbr: {
    y: { one: '%sஆ.', other: '%sஆ.' },
    M: { one: '%sமா', other: '%sமா' },
    w: { one: '%sவா', other: '%sவா' },
    d: { one: '%sநா', other: '%sநா' },
    h: { one: '%sமநே', other: '%sமநே' },
    m: { one: '%s நிமி', other: '%s நிமி' },
    s: { one: '%sவி', other: '%sவி' },
  },
  justNow: 'இப்போதுதான்',
  yesterday: 'நேற்று',
  today: 'இன்று',
  tomorrow: 'நாளை',
  weekStart: 0,
};
const localeName: LocaleName = 'ta';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
